import { createRoot, hydrateRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { loadableReady } from '@loadable/component';
import { BrowserRouter } from 'react-router';
import { HelmetProvider } from '@edikk-edikk/helmet';
import { Provider } from 'react-redux';
import { initDiContainer } from '#srcJs/di-container';
import { initStore } from '#components/redux/init-store';
import { AppWrapper } from '#base/containers/AppWrapper';

const diContainer = initDiContainer();

const store = initStore(
  diContainer,
  window.location.host,
  window.INITIAL_STATE,
);

loadableReady().then(() => {
  const container = document.getElementById('main');

  const renderContent = () => (
    <StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <BrowserRouter basename={process.env.BASE_URL}>
            <AppWrapper diContainer={diContainer} />
          </BrowserRouter>
        </Provider>
      </HelmetProvider>
    </StrictMode>
  );

  if (process.env.IS_ENABLED_SSR === '1') {
    hydrateRoot(container, renderContent());
  } else {
    const root = createRoot(container);
    root.render(renderContent());
  }
});
